import { getCanonicalUrl, getShareableUrl } from './utils/url';
import { measureRequests } from './utils/perf';

(function (formsReadyQueue) {
  function listenForFormReady() {
    window._hsq.push(['setCanonicalUrl', getCanonicalUrl()]);

    window.HubSpotForms.onFormReady(function () {
      window.HubSpotForms.currentForm._setPageUrl(
        getShareableUrl() + '' + window.location.search
      );

      document.querySelector('.container').classList.add('loaded');
      measureRequests();
    });
    window.HubSpotForms.onRenderError(function () {
      document.querySelector('.container').classList.add('error');
    });
  }

  if (window.HubSpotForms) {
    listenForFormReady();
  }
  formsReadyQueue.push(listenForFormReady);
})(window.hsFormsOnReady);
